import type { CargaTrabalhoAgrupamento } from "@/modules/carga-trabalho";
import type { EmptyStateContent } from "../types-carga-de-trabalho";

export const AGRUPAMENTO_OPTIONS: { label: string; value: CargaTrabalhoAgrupamento }[] = [
  { label: "Profissionais", value: "profissionais" },
  { label: "Obras", value: "obras" },
];

/** Dica do "Agrupar por" (Figma: tooltip · Visualizar por). */
export const GROUPING_HINT =
  "Muda como as linhas são agrupadas: por obra ou pelo recurso. Os dados são os mesmos.";

export const VAZIO_SEM_ALOCACAO: EmptyStateContent = {
  title: "Nenhuma alocação encontrada",
  description: "Não há alocações de profissionais no período selecionado.",
};
